import React from "react";
import fakeContentService from "../services/fakeContentService";
import fakeProfilesService from "../services/fakeProfilesService";
import ContentBlockquote from "./StateLessComponents/ContentBlockquote";
import ContentImage from "./StateLessComponents/ContentImage";
import VisitcardComponent from "./StateLessComponents/VisitcardComponent";

class SenatorsComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingPartner: []
        };
    }

    async componentDidMount() {
        const bookingPartner = await fakeProfilesService.getProfiles({ filter: p => { return p.bookPed === "x" } });
        const content = await fakeContentService.getSenatorsContent();

        this.setState({
            bookingPartner,
            content
        })
    }

    render() {
        const { bookingPartner, content } = this.state;

        return (
            <div>
                <h1 className="kgnsf-header">Unsere Senatoren</h1>

                <ContentImage image={"/images/neustadtfunken/senators/Senatoren.jpg"} label={"Unsere Senatoren"} />

                <ContentBlockquote content={content} />

                <div>
                    <a className="btn btn-danger end" href={'/files/Senatoren Aufnahmeantrag_18.11.2025.pdf'} key={'Senatoren Aufnahmeantrag'} target="_blank" rel="noreferrer">
                        <i className="bi bi-download"></i> {'Senatoren Aufnahmeantrag'}
                    </a>
                </div>

                <br/>
                <br/>
                {/* <div className='row justify-content-end'>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        {bookingPartner && <VisitcardComponent title="Bei Fragen / Interesse" profiles={bookingPartner}></VisitcardComponent>}
                    </div>
                </div> */}
            </div >
        )
    }
}

export default SenatorsComponent